import styled from 'styled-components';

export const CategoryTabsWrap = styled.div`
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  background-color: #fff;
  margin-bottom: 15px;

  .rmc-tabs-tab-bar-tab {
    flex: 1 !important;
    padding: 12px 0;
    color: #666;
    font-size: 14px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cc_notice_tab_with_badge {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
  .cc_notice_tab_title {
    display: inline-block;
  }

  .rmc-tabs-tab-bar-tab-active {
    color: #000000 !important;
    font-weight: bold;
  }
  .custom-tab-content {
    margin-top: 0px !important;
  }
    
`;
